import { Modal, Paragraph } from '@vwfs-bronson/bronson-react';
import { MINUTES_TO_AUTO_LOGOUT } from '../../KeycloakWrapper';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import keycloakClient from '../../services/api/login/keycloak';

export function TimeOutNotification(props) {
    const ONE_MINUTE_IN_SECONDS = 60;
    const { t } = useTranslation()
    const { keycloakIdp } = props
    const brandName = process.env.REACT_APP_BRAND
    const keycloak = React.useMemo(() => {
        return keycloakIdp === 'vwfs'
        ? keycloakClient.vwfs.kc
        : keycloakClient[brandName].kc
    }, [keycloakIdp, brandName])
    const [timeLeft, setTimeLeft] = useState(MINUTES_TO_AUTO_LOGOUT * ONE_MINUTE_IN_SECONDS);
    const isAuthenticated = keycloak.authenticated;
    const [isNotificationVisible, setIsNotificationVisible] = useState(false);
    const minutes = Math.floor(timeLeft / ONE_MINUTE_IN_SECONDS);
    const seconds = timeLeft % ONE_MINUTE_IN_SECONDS;
    const formattedSeconds = String(seconds).padStart(2, '0');
    const resetTimer = () => {
        setIsNotificationVisible(false);
        setTimeLeft(MINUTES_TO_AUTO_LOGOUT * ONE_MINUTE_IN_SECONDS);
    };
    useEffect(() => {
        document.getElementById('root')?.addEventListener('click', resetTimer);
        window.addEventListener('scroll', resetTimer);
        document.getElementById('root')?.addEventListener('keydown', resetTimer);

        return () => {
            window.removeEventListener('scroll', resetTimer);
            document.getElementById('root')?.removeEventListener('keydown', resetTimer);
            document.getElementById('root')?.removeEventListener('click', resetTimer);
        };
    }, []);
    useEffect(() => {
        if (!isAuthenticated) {
            return;
        }

        const timer = setInterval(() => {
            setTimeLeft((prevTime) => {
                if (prevTime - ONE_MINUTE_IN_SECONDS <= 1) {
                    setIsNotificationVisible(true);
                }

                if (prevTime <= 1) {
                    clearInterval(timer);
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);
        return () => clearInterval(timer);
    }, [isAuthenticated]);

    return (isNotificationVisible 
        ? <Modal
            title=""
            shown
            asPortal
            onClickOutside={resetTimer}
            onClose={resetTimer}
            buttonConfirmText={t('form:timeOutNotification:continueButtonLabel')}
            buttonConfirmType="submit"
            onConfirm={resetTimer}
            headingLevel={2}
        >
            <Paragraph>
                {`${t('form:timeOutNotification:sessionAboutToExpire')} ${minutes}:${formattedSeconds}`}
            </Paragraph>
        </Modal>
        : null)
};
